<app-advisor-errorpage *ngIf="hasError === true"></app-advisor-errorpage>

<div class="grid-container" *ngIf="hasError === false">
  <div class="grid-x grid-margin-x headline-wrapper">
    @if(forceDialog || showDownload) {
      <div class="cell small-12 large-12">
        <dialog-hint [clickTarget]="idTargetElement" textkey="wpcheck.ergebnis.callout" [closable]="true"></dialog-hint>
      </div>
    }
    <div class="cell small-12 large-offset-1 large-10 text-center">
      <h1 [innerHTML]="'wpcheck.ergebnis.headline' | translate"></h1>
    </div>
  </div>

  <div class="grid-x grid-margin-x" *ngIf="overallRating">
    <div class="cell small-12">
      <div class="resultimage-wrapper">
        <app-advisor-image [path]="anfrage.userInput?.gebaeudetyp === 'mehrfamilienhaus'? '/wpc/wpc-ergebnis-mfh.svg' : '/wpc/wpc-ergebnis-efh.svg'"></app-advisor-image>
        <div class="bubble-wrapper">
          <p class="bubble" [innerHTML]="'wpcheck.ergebnis.geeignet.' + overallRating | translate"></p>
          <p class="bubble" [innerHTML]="'wpcheck.ergebnis.aufwand.' + overallRating | translate"></p>
        </div>
      </div>
    </div>
  </div>

  <div class="grid-x grid-margin-x">
    <div class="cell small-12">
      <h2 [innerHTML]="'wpcheck.ergebnis.accordion.headline' | translate"></h2>

      <div class="accordion-wrapper" *ngIf="accordion">
        <mat-accordion multi displayMode="flat">
          <mat-expansion-panel *ngFor="let row of accordion;">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <i [class]="'rating-' + row.rating"></i>
                <h3 [innerHTML]="'wpcheck.ergebnis.accordion.' + row.name + '.headline.' + row.text | translate"></h3>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="grid-x">
              <div class="cell small-12" [innerHTML]="'wpcheck.ergebnis.accordion.' + row.name + '.text.' + row.text | translate"></div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </div>

  <div class="pump-info-wrapper">
   <h2 [innerHTML]="'wpcheck.ergebnis.infos.headline' | translate"></h2>

    <mat-tab-group mat-align-tabs="start">
      <mat-tab *ngFor="let topic of pumpInfoTopics">
        <ng-template mat-tab-label>
          <i [class]="'icon-pump-' + topic"></i>
          <span [innerHTML]="'wpcheck.ergebnis.infos.' + topic + '.headline' | translate"></span>
        </ng-template>
        <div class="content">
          <p [innerHTML]="'wpcheck.ergebnis.infos.' + topic + '.teaser' | translate"></p>
          <div class="grid-x">
            <div class="cell medium-6">
              <strong [innerHTML]="'wpcheck.ergebnis.infos.pro' | translate"></strong>
              <div [innerHTML]="'wpcheck.ergebnis.infos.' + topic + '.pro' | translate"></div>
            </div>
            <div class="cell medium-6">
              <strong [innerHTML]="'wpcheck.ergebnis.infos.contra' | translate"></strong>
              <div [innerHTML]="'wpcheck.ergebnis.infos.' + topic + '.contra' | translate"></div>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

  <app-advisor-teaser *ngIf="mocRating === '+1'" [placeholder]="placeholder" textPrefix="wpcheck.ergebnis.mocteaser" [textPostfix]="'.' + mocRating" [headlinePostfix]="'.' + mocRating"
                      image="/wpc/moc-teaser.svg" [url]="mocUrl" target="_self" [mailUrl]="mocUrlMail"></app-advisor-teaser>

  <app-dialogform [id]="idTargetElement" *ngIf="forceDialog" textkeyPrefix="wpcheck" copyright=".dialogform.copyright" advisorImagePath="/wpc/pdf-lead.svg" [registrationData]="dialogData" (onDialogRegister)="dialogRegistered($event)"></app-dialogform>

  <div class="grid-x grid-margin-x" *ngIf="showDownload" id="wpcheck-download">
    <div class="cell small-12">
      <h2 [innerHTML]="'wpcheck.ergebnis.weg.headline' | translate"></h2>

      <app-download [id]="idTargetElement" [url]="reportUrl" textkeyPrefix="wpcheck.ergebnis."></app-download>
    </div>
  </div>

  <app-portal-teaser></app-portal-teaser>

  <div class="grid-x grid-margin-x">
    <div class="cell small-12">
      <h2 [innerHTML]="'wpcheck.ergebnis.faq.headline' | translate"></h2>
    </div>

    <div class="cell faq-wrapper">
      <mat-accordion multi displayMode="flat">
        <mat-expansion-panel *ngFor="let row of faqTopics;">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <h3 [innerHTML]="'wpcheck.ergebnis.faq.' + row + '.headline' | translate"></h3>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="grid-x">
            <div class="cell small-12" [innerHTML]="'wpcheck.ergebnis.faq.' + row + '.text' | translate">

            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>

  <app-donate *ngIf="internalPortal === true" textkeyPrefix="wpcheck"></app-donate>
</div>

<div class="grid-x grid-padding-x" *ngIf="hasError === false">
  <div class="cell">
    <app-step-buttons previousLink="../../eingabe/massnahmen/5"
                      mediumWidthRight="10" mediumOffset="auto" leftAlignSize="" largeOffset="auto" largeWidthRight="10"
                      previousText="step.button.previous" [nextLink]="null" [nextSubmit]="false"></app-step-buttons>
  </div>
</div>
